import { api } from './api'

const apiVersion = 'v2'

export const materialsApi = api
    .enhanceEndpoints({
        addTagTypes: ['Materials'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getMaterials: builder.query({
                query: ({ organisationId }) => `/${apiVersion}/organisation/${organisationId}/materials`,
                transformResponse: (response) => {
                    delete response.$type

                    return response
                },
                providesTags: (result, _error, _arg) =>
                    result
                        ? [
                              { type: 'Materials', id: 'LIST' },

                              ...(Object.values(result)?.map(({ materialId }) => ({
                                  type: 'Materials',
                                  id: materialId,
                              })) ?? []),
                          ]
                        : [{ type: 'Materials', id: 'LIST' }],
            }),

            getMaterial: builder.query({
                query: ({ materialId, organisationId }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/materials/${materialId}`,
                }),
                providesTags: (result, _error, arg) => [
                    { type: 'Materials', id: arg.materialId },
                    { type: 'Sheets', id: 'LIST' },
                    ...(result.sheets.map(({ sheetId }) => ({ type: 'Sheets', id: sheetId })) ?? []),
                ],
            }),

            createMaterialList: builder.mutation({
                query: ({ organisationId }) => ({
                    url: `/organisations/${organisationId}/materials`,
                    method: 'POST',
                }),
            }),

            createOrderMaterialList: builder.mutation({
                query: ({ location, organisationId }) => {
                    let url = `/organisations/${organisationId}/quote-materials`
                    if (location && location.length > 0) {
                        url += `?location=${location}`
                    }
                    return {
                        url,
                        method: 'POST',
                    }
                },
            }),
        }),
    })

export const selectMaterials = (state, query) => {
    return materialsApi.endpoints.getMaterials.select(query)(state)?.data ?? []
}

export const {
    useCreateMaterialListMutation,
    useCreateOrderMaterialListMutation,
    useGetMaterialQuery,
    useGetMaterialsQuery,
    useLazyGetMaterialQuery,
    useLazyGetMaterialsQuery,
} = materialsApi
